<template>
  <div class="news" id="news-count">
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="最新动态/企校合作" name="first">
          <el-row :gutter="50">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="block">
                <el-carousel trigger="click" height="371px" style="background-color: rgba(0,0,0,0.5);"
                  :autoplay="false">
                  <el-carousel-item v-for="(item,index) in data1" :key="index">
                    <h3 class="small">
                      <el-link @click="toContent(item.id)">
                        <el-image :src="$http+item.file" style="border: 1px solid rgba(0,0,0,0.3);"
                          fit="fill"></el-image>
                      </el-link>
                      <div class="small-title">
                        <h4>{{item.title}}</h4>
                        <!-- <div class="small-content">
                          <p v-html="item.content">{{item.content}}</p>
                        </div> -->
                      </div>
                    </h3>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <template>
                <el-table :data="data2" style="width: 100%">
                  <el-table-column label="id" width="0">
                    <template slot-scope="scope">
                      <span>{{ scope.row.id }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="标题">
                    <template slot-scope="scope">
                      <!-- <i class="rudius"></i> -->
                      <el-link @click="toContent(scope.row.id)" target="_blank"
                        :underline="false">{{ scope.row.title }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column label="日期" width="100">
                    <template slot-scope="scope">
                      <span>{{ timestampToDate(scope.row.createtime)}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        image: [],
        tableData: [],
        activeName: 'first',
        none: "fill",
        data1: [],
        data2: []
      };
    },
    mounted: function() {
      this.loadData();
      this.loadImage();
    },
    methods: {
      handleClick(tab, event) {},
      loadData() {
        this.axios.get(this.$http + "api/index/getNews", {
            params: {
              limit: 6
            }
          })
          .then((res) => {
            this.data1 = res.data.data.data1.data;
            this.data2 = res.data.data.data2.data;
          })
          .catch((err) => {})
      },
      loadImage() {
        this.axios.get(process.env.API_ROOT + "/admin/news/getImagetext")
          .then((res) => {
            this.tableData = [];
            var count = 6;
            if (res.data.data.length > 5) {
              count = 6;
            } else {
              count = res.data.data.length
            }
            for (var i = 0; i < count; i++) {
              this.tableData.push({
                id: res.data.data[i].id,
                title: res.data.data[i].title,
                time: res.data.data[i].time,
                xvhao: res.data.data[i].xvhao,
                type: res.data.data[i].type
              });
            }
          })
          .catch((err) => {

          })
      },
      timestampToDate(timestamp) {
        const date = new Date(timestamp * 1000); // 将时间戳转换为Date对象
        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }; // 设置日期格式
        return new Intl.DateTimeFormat('zh-CN', options).format(date);
      },
      toContent: function(mallCode1, mallCode2) {
        this.$router.push({
          path: '/content',
          query: {
            number: mallCode1,
            type: mallCode2
          }
        })
      },
    }
  };
</script>

<style scoped>
  h3.small {
    height: 100%;
    width: 100%;
  }

  h3.small>a.el-link {
    width: 100%;
    height: 100%;
  }

  /deep/ h3.small span.el-link--inner {
    width: 100%;
    height: 100%;
  }

  /deep/ h3.small span.el-link--inner .el-image {

    display: block;
  }

  .el-carousel__item h3 {
    line-height: 18px !important;
    opacity: 1 !important;
  }

  /deep/ .el-carousel__indicators--horizontal {
    display: none;
  }

  /deep/ .el-table_1_column_3 .cell {
    text-align: right;
  }

  /deep/ .cell,.cell .el-link{
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/News.vue